import { z } from 'zod';

const salaryEvidenceBaseSchema = z.object({
    qualification: z.enum(['actual', 'desired', 'unqualified']),
    periodicity: z.enum(['annual', 'daily']),
    minAmount: z.number().positive(),
    maxAmount: z.number().positive().nullable(),
    annualBillableDays: z.number().int().min(1).max(366).nullable(),
});

export const salaryEvidenceSchema = salaryEvidenceBaseSchema.extend({
    sourceKind: z.enum(['note', 'cv']),
    sourceDate: z.string().datetime({ offset: true }).nullable(),
}).refine(({ minAmount, maxAmount }) => maxAmount === null || maxAmount >= minAmount, {
    message: 'maxAmount must be greater than or equal to minAmount',
    path: ['maxAmount'],
});

export const SALARY_EVIDENCE_INSTRUCTION =
    'Règle obligatoire et prioritaire : extraire chaque mention de rémunération sous forme de faits bruts, sans calculer de salaire annuel. ' +
    'Pour une fourchette, minAmount doit contenir la borne basse et maxAmount la borne haute, avec maxAmount supérieur ou égal à minAmount. ' +
    'Pour un montant unique, utiliser maxAmount null. ' +
    'Pour « 46k », utiliser periodicity annual et minAmount 46000. Pour « TJM 650 €, environ 180 jours facturés/an », ' +
    'utiliser periodicity daily, minAmount 650 et annualBillableDays 180. Utiliser qualification unqualified lorsqu’aucun ' +
    'caractère actuel ou souhaité n’est explicite. sourceDate doit être la date de la source au format ISO 8601 avec ' +
    'fuseau horaire lorsqu’elle est connue, sinon null. Retourner un tableau vide si aucune rémunération n’est trouvée.';

export const SALARY_COMPATIBILITY_INSTRUCTION =
    'Champ conservé uniquement pour compatibilité. Ne pas calculer ni recopier de rémunération dans ce champ : retourner null. ' +
    'salaryEvidence est l’unique source utilisée par le backend pour qualifier et annualiser les rémunérations.';

export const salaryEvidenceListSchema = z
    .array(salaryEvidenceSchema)
    .describe(`Preuves brutes de rémunération utilisées exclusivement par le backend. ${SALARY_EVIDENCE_INSTRUCTION}`);

export type SalaryEvidence = z.infer<typeof salaryEvidenceSchema>;
